// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"2eaR5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread);
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"24f9u","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"24f9u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_define_property);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"ktu2Q":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"kR5CL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread_props);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"ffd5s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_CITY", ()=>DEFAULT_CITY);
parcelHelpers.export(exports, "AVAILABLE_CITIES", ()=>AVAILABLE_CITIES);
parcelHelpers.export(exports, "getConfigForCity", ()=>getConfigForCity);
parcelHelpers.export(exports, "getCurrentCity", ()=>getCurrentCity);
parcelHelpers.export(exports, "isCitySupported", ()=>isCitySupported);
parcelHelpers.export(exports, "getCityBounds", ()=>getCityBounds);
parcelHelpers.export(exports, "getCityInfo", ()=>getCityInfo);
var _getRoute = require("./utils/getRoute");
var _getRouteDefault = parcelHelpers.interopDefault(_getRoute);
var _cityConfig = require("./city-config");
const DEFAULT_CITY = (0, _cityConfig.DEFAULT_CITY);
const AVAILABLE_CITIES = (0, _cityConfig.AVAILABLE_CITIES);
const getConfigForCity = (0, _cityConfig.getConfigForCity);
const getCurrentCity = ()=>{
    try {
        const { city } = (0, _getRouteDefault.default)();
        return city || DEFAULT_CITY;
    } catch (e) {
        return DEFAULT_CITY;
    }
};
const isCitySupported = (cityCode)=>{
    if (cityCode === 'all') return (0, _cityConfig.isAlphaEnabled)();
    return !!(0, _cityConfig.CITY_CONFIGS)[cityCode];
};
// India/South-Asia initial extent used when city === 'all'
const ALL_MODE_BOUNDS = [
    66,
    6,
    98,
    38
];
const getCityBounds = ()=>{
    var _config_city;
    const currentCity = getCurrentCity();
    if (currentCity === 'all') return ALL_MODE_BOUNDS;
    const config = getConfigForCity(currentCity);
    if (!(config === null || config === void 0 ? void 0 : (_config_city = config.city) === null || _config_city === void 0 ? void 0 : _config_city.bounds)) return [
        0,
        0,
        0,
        0
    ]; // Safe fallback
    const { lowerLat, upperLat, lowerLong, upperLong } = config.city.bounds;
    return [
        lowerLong,
        lowerLat,
        upperLong,
        upperLat
    ];
};
const getCityInfo = ()=>{
    const config = getConfigForCity(getCurrentCity());
    return config === null || config === void 0 ? void 0 : config.city;
};
// Default export returns current city's config
exports.default = ()=>getConfigForCity(getCurrentCity());

},{"./utils/getRoute":"kYEZr","./city-config":"7oMBO","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"kYEZr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAllModeValue", ()=>parseAllModeValue);
var _config = require("../config");
const parseAllModeValue = (value)=>{
    if (!value) return [];
    return value.split('~').map((part)=>{
        const idx = part.indexOf('^');
        if (idx === -1) return null;
        return {
            city: part.slice(0, idx),
            id: part.slice(idx + 1)
        };
    }).filter(Boolean);
};
exports.default = ()=>{
    const path = location.hash.replace(/^#/, '') || '/';
    // Handle root path
    if (path === '/') return {
        page: 'home',
        city: (0, _config.DEFAULT_CITY)
    };
    // Extract city code if present (case insensitive); 'all' is a valid reserved code
    const cityMatch = path.match(/^\/([A-Za-z]*)(\/|$)/);
    const city = cityMatch ? cityMatch[1].toLowerCase() : (0, _config.DEFAULT_CITY);
    // Remove city prefix from path for route matching
    const routePath = cityMatch ? path.substring(cityMatch[0].length) : path;
    // Match route components
    let [_, page, value, subpage] = routePath.match(/(service|stop|between|location|vehicle)s?\/([^\/]+)\/?([^\/]+)?/) || [];
    // Decode URI components to handle encoded whitespace and special characters
    try {
        if (page) page = decodeURIComponent(page);
        if (value) value = decodeURIComponent(value);
        if (subpage) subpage = decodeURIComponent(subpage);
    } catch (e) {}
    return {
        city,
        page: page || 'home',
        value,
        path,
        subpage,
        cityPrefix: `/${city}`
    };
};

},{"../config":"ffd5s","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"7oMBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FALLBACK_CITY", ()=>FALLBACK_CITY);
parcelHelpers.export(exports, "DEFAULT_CITY", ()=>DEFAULT_CITY);
parcelHelpers.export(exports, "isDevMode", ()=>isDevMode);
parcelHelpers.export(exports, "isApiDisabled", ()=>isApiDisabled);
parcelHelpers.export(exports, "isAlphaEnabled", ()=>isAlphaEnabled);
parcelHelpers.export(exports, "AVAILABLE_CITIES", ()=>AVAILABLE_CITIES);
parcelHelpers.export(exports, "CITY_CONFIGS", ()=>CITY_CONFIGS);
parcelHelpers.export(exports, "isDevelopmentMode", ()=>isDevelopmentMode);
parcelHelpers.export(exports, "getApiBaseUrl", ()=>getApiBaseUrl);
parcelHelpers.export(exports, "getApiUrl", ()=>getApiUrl);
parcelHelpers.export(exports, "getConfigForCity", ()=>getConfigForCity);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
const FALLBACK_CITY = 'blr';
const pref = (key)=>localStorage.getItem(key);
const storedDefaultCity = pref('defaultCity');
const DEFAULT_CITY = storedDefaultCity && storedDefaultCity !== 'auto' ? storedDefaultCity : FALLBACK_CITY;
const isDevMode = ()=>pref('devMode') === 'true';
const isApiDisabled = ()=>isDevMode() && pref('disableApi') === 'true';
const isAlphaEnabled = ()=>isDevMode() && pref('alphaFeatures') === 'true';
const AVAILABLE_CITIES = [
    'blr',
    'chennai',
    'delhi',
    'goa',
    'kochi',
    'pune',
    'mumbai',
    'hublidharwad',
    'karnataka',
    'telangana',
    'andhrapradesh',
    'ahmedabad',
    'indore',
    'rajkot',
    'railways',
    'greyhound',
    'nyc'
];
const CITY_CONFIGS = {
    blr: {
        city: {
            name: 'Bengaluru',
            code: 'blr',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 12.8,
                upperLat: 13.15,
                lowerLong: 77.4,
                upperLong: 77.75,
                minZoom: 8
            }
        },
        liveArrivals: {
            enabled: true,
            apiPath: '/api/bmtc/arrivals'
        },
        liveVehicles: {
            enabled: true,
            apiPath: '/api/bmtc/vehicles'
        },
        vehicleLookup: {
            enabled: true,
            apiPath: '/api/bmtc/vehicle'
        },
        stopRoutes: {
            enabled: true,
            apiPath: '/api/bmtc/stop-routes'
        },
        stopVehicles: {
            enabled: true,
            apiPath: '/api/bmtc/stop-vehicles'
        },
        normalizeNames: {
            enabled: true,
            removeChars: [
                '-',
                ' '
            ]
        },
        maxArrivalTime: 7200000,
        // 2 hours in milliseconds
        disableStopID: true
    },
    karnataka: {
        city: {
            name: 'Karnataka',
            code: 'karnataka',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 11.5,
                upperLat: 18.5,
                lowerLong: 74.0,
                upperLong: 78.6,
                minZoom: 6
            }
        }
    },
    goa: {
        city: {
            name: 'Goa',
            code: 'goa',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 15.1,
                upperLat: 15.9,
                lowerLong: 73.75,
                upperLong: 74.15,
                minZoom: 8
            }
        }
    },
    kochi: {
        city: {
            name: 'Kochi',
            code: 'kochi',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 9.8,
                upperLat: 10.2,
                lowerLong: 76.25,
                upperLong: 76.55,
                minZoom: 8
            }
        }
    },
    chennai: {
        city: {
            name: 'Chennai',
            code: 'chennai',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 12.85,
                upperLat: 13.35,
                lowerLong: 80.0,
                upperLong: 80.4,
                minZoom: 8
            }
        }
    },
    delhi: {
        city: {
            name: 'Delhi',
            code: 'delhi',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 28.35,
                upperLat: 28.95,
                lowerLong: 76.95,
                upperLong: 77.55,
                minZoom: 8
            }
        },
        liveVehicles: {
            enabled: true,
            apiPath: '/api/delhi/vehicles'
        },
        vehicleLookup: {
            enabled: true,
            apiPath: '/api/delhi/vehicle'
        }
    },
    pune: {
        city: {
            name: 'Pune',
            code: 'pune',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 18.35,
                upperLat: 18.75,
                lowerLong: 73.65,
                upperLong: 74.05,
                minZoom: 8
            }
        },
        liveArrivals: {
            enabled: true,
            apiPath: '/api/pmpml/arrivals'
        },
        liveVehicles: {
            enabled: true,
            apiPath: '/api/pmpml/vehicles'
        },
        vehicleLookup: {
            enabled: true,
            apiPath: '/api/pmpml/vehicle'
        },
        stopRoutes: {
            enabled: true,
            apiPath: '/api/pmpml/stop-routes'
        },
        stopVehicles: {
            enabled: true,
            apiPath: '/api/pmpml/stop-vehicles'
        },
        maxArrivalTime: 7200000 // 2 hours in milliseconds
    },
    mumbai: {
        city: {
            name: 'Mumbai',
            code: 'mumbai',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 18.90,
                upperLat: 19.31,
                lowerLong: 72.78,
                upperLong: 73.16,
                minZoom: 8
            }
        }
    },
    hublidharwad: {
        city: {
            name: 'Hubli-Dharwad',
            code: 'hublidharwad',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 15.27,
                upperLat: 15.53,
                lowerLong: 74.77,
                upperLong: 75.35,
                minZoom: 9
            }
        }
    },
    telangana: {
        city: {
            name: 'Telangana',
            code: 'telangana',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 15.5,
                upperLat: 20.5,
                lowerLong: 77.0,
                upperLong: 82.0,
                minZoom: 7
            }
        }
    },
    andhrapradesh: {
        city: {
            name: 'Andhra Pradesh',
            code: 'andhrapradesh',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 12.4,
                upperLat: 19.7,
                lowerLong: 77.0,
                upperLong: 85.5,
                minZoom: 6
            }
        }
    },
    ahmedabad: {
        city: {
            name: 'Ahmedabad',
            code: 'ahmedabad',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 22.82,
                upperLat: 23.25,
                lowerLong: 72.28,
                upperLong: 72.83,
                minZoom: 9
            }
        }
    },
    indore: {
        city: {
            name: 'Indore',
            code: 'indore',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 22.5,
                upperLat: 22.9,
                lowerLong: 75.6,
                upperLong: 76.1,
                minZoom: 9
            }
        }
    },
    rajkot: {
        city: {
            name: 'Rajkot',
            code: 'rajkot',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: 22.11,
                upperLat: 22.44,
                lowerLong: 70.65,
                upperLong: 70.96,
                minZoom: 9
            }
        }
    },
    railways: {
        city: {
            name: 'Railways',
            code: 'railways',
            flag: "\uD83C\uDDEE\uD83C\uDDF3",
            bounds: {
                lowerLat: -5,
                upperLat: 45,
                lowerLong: 70,
                upperLong: 100,
                minZoom: 4.8
            }
        },
        liveArrivals: {
            enabled: true,
            apiPath: '/api/railways/arrivals'
        },
        liveVehicles: {
            enabled: true,
            apiPath: '/api/railways/vehicles'
        },
        stopRoutes: {
            enabled: true,
            apiPath: '/api/railways/stop-routes'
        },
        stopVehicles: {
            enabled: true,
            apiPath: '/api/railways/stop-vehicles'
        },
        vehicleLookup: {
            enabled: true,
            apiPath: '/api/railways/vehicle'
        }
    },
    greyhound: {
        city: {
            name: 'Greyhound',
            code: 'greyhound',
            flag: "\uD83C\uDDFA\uD83C\uDDF8",
            bounds: {
                lowerLat: 24.9493,
                upperLat: 49.5904,
                lowerLong: -125.0011,
                upperLong: -66.9326,
                minZoom: 4.7
            }
        },
        disableStopID: true
    },
    nyc: {
        city: {
            name: 'New York City',
            code: 'nyc',
            flag: "\uD83C\uDDFA\uD83C\uDDF8",
            bounds: {
                lowerLat: 40.5,
                upperLat: 41.0,
                lowerLong: -74.5,
                upperLong: -73.5,
                minZoom: 9
            }
        },
        disableStopID: true
    }
};
const isDevelopmentMode = ()=>{
    return typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
};
const getApiBaseUrl = ()=>{
    return isDevelopmentMode() ? window.location.origin : '';
};
const getApiUrl = (apiPath)=>{
    if (!apiPath) return null;
    if (isApiDisabled()) return null;
    return `${getApiBaseUrl()}${apiPath}`;
};
// 'all' (every city combined — see IS_ALL_MODE in app.js) isn't a real
// entry in CITY_CONFIGS — it never had its own city-specific data. Bounds
// match config.js's own ALL_MODE_BOUNDS ([66, 6, 98, 38], lng/lat order)
// so callers reading city.bounds (title bar, city info displays, etc.)
// see something consistent with what the map actually frames in all-mode.
const ALL_CITY_CONFIG = {
    city: {
        name: 'All',
        code: 'all',
        flag: "\uD83C\uDF10",
        bounds: {
            lowerLat: 6,
            upperLat: 38,
            lowerLong: 66,
            upperLong: 98,
            minZoom: 4
        }
    }
};
const getConfigForCity = (cityCode)=>{
    // Falling through to CITY_CONFIGS[DEFAULT_CITY] here (like every other
    // city code does below) would silently show whatever city DEFAULT_CITY
    // happens to be instead of "All" — and if DEFAULT_CITY is itself 'all'
    // (a valid choice now that the settings drawer offers it), that
    // fallback resolves to undefined and crashes the first caller that
    // reads .city off of it (e.g. the page-title effect in app.js).
    if (cityCode === 'all') return ALL_CITY_CONFIG;
    const config = CITY_CONFIGS[cityCode] || CITY_CONFIGS[DEFAULT_CITY];
    if (!config) return null;
    var _config_maxArrivalTime, _config_disableStopID;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
        maxArrivalTime: (_config_maxArrivalTime = config.maxArrivalTime) !== null && _config_maxArrivalTime !== void 0 ? _config_maxArrivalTime : 86400000,
        disableStopID: (_config_disableStopID = config.disableStopID) !== null && _config_disableStopID !== void 0 ? _config_disableStopID : false
    });
};

},{"@swc/helpers/_/_object_spread":"2eaR5","@swc/helpers/_/_object_spread_props":"kR5CL","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"kNdlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lscache = require("lscache");
var _lscacheDefault = parcelHelpers.interopDefault(_lscache);
// Track in-flight requests to avoid duplicate fetches
const inFlightRequests = new Map();
exports.default = (url, timeout)=>{
    // Check local storage cache first
    const data = (0, _lscacheDefault.default).get(url);
    if (data) return Promise.resolve(data);
    // Check if there's already an in-flight request for this URL
    if (inFlightRequests.has(url)) return inFlightRequests.get(url);
    // Create the fetch promise
    const fetchPromise = fetch(url).then((r)=>{
        if (!r.ok) throw new Error(`HTTP ${r.status}: ${r.statusText}`);
        const contentType = r.headers.get('content-type');
        if (contentType && !contentType.includes('application/json')) throw new Error(`Expected JSON but got ${contentType}`);
        return r.text().then((text)=>{
            if (!text || text.trim().length === 0) throw new Error('Empty response');
            try {
                return JSON.parse(text);
            } catch (e) {
                throw new Error(`JSON.parse: ${e.message}`);
            }
        });
    }).then((r)=>{
        (0, _lscacheDefault.default).set(url, r, timeout);
        return r;
    }).catch((error)=>{
        throw error;
    }).finally(()=>{
        // Remove from in-flight requests when done
        inFlightRequests.delete(url);
    });
    // Track this request
    inFlightRequests.set(url, fetchPromise);
    return fetchPromise;
};

},{"lscache":"cDPkR","@parcel/transformer-js/src/esmodule-helpers.js":"ktu2Q"}],"cDPkR":[function(require,module,exports,__globalThis) {
/**
 * lscache library
 * Copyright (c) 2011, Pamela Fox
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* jshint undef:true, browser:true, node:true */ /* global define */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (module.exports) // CommonJS/Node module
    module.exports = factory();
    else // Browser globals
    root.lscache = factory();
})(this, function() {
    // Prefix for all lscache keys
    var CACHE_PREFIX = 'lscache-';
    // Suffix for the key name on the expiration items in localStorage
    var CACHE_SUFFIX = '-cacheexpiration';
    // expiration date radix (set to Base-36 for most space savings)
    var EXPIRY_RADIX = 10;
    // time resolution in milliseconds
    var expiryMilliseconds = 60000;
    // ECMAScript max Date (epoch + 1e8 days)
    var maxDate = calculateMaxDate(expiryMilliseconds);
    var cachedStorage;
    var cachedJSON;
    var cacheBucket = '';
    var warnings = false;
    // Determines if localStorage is supported in the browser;
    // result is cached for better performance instead of being run each time.
    // Feature detection is based on how Modernizr does it;
    // it's not straightforward due to FF4 issues.
    // It's not run at parse-time as it takes 200ms in Android.
    function supportsStorage() {
        var key = '__lscachetest__';
        var value = key;
        if (cachedStorage !== undefined) return cachedStorage;
        // some browsers will throw an error if you try to access local storage (e.g. brave browser)
        // hence check is inside a try/catch
        try {
            if (!localStorage) return false;
        } catch (ex) {
            return false;
        }
        try {
            setItem(key, value);
            removeItem(key);
            cachedStorage = true;
        } catch (e) {
            // If we hit the limit, and we don't have an empty localStorage then it means we have support
            if (isOutOfSpace(e) && localStorage.length) cachedStorage = true; // just maxed it out and even the set test failed.
            else cachedStorage = false;
        }
        return cachedStorage;
    }
    // Check to set if the error is us dealing with being out of space
    function isOutOfSpace(e) {
        return e && (e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.name === 'QuotaExceededError');
    }
    // Determines if native JSON (de-)serialization is supported in the browser.
    function supportsJSON() {
        /*jshint eqnull:true */ if (cachedJSON === undefined) cachedJSON = window.JSON != null;
        return cachedJSON;
    }
    /**
   * Returns a string where all RegExp special characters are escaped with a \.
   * @param {String} text
   * @return {string}
   */ function escapeRegExpSpecialCharacters(text) {
        return text.replace(/[[\]{}()*+?.\\^$|]/g, '\\$&');
    }
    /**
   * Returns the full string for the localStorage expiration item.
   * @param {String} key
   * @return {string}
   */ function expirationKey(key) {
        return key + CACHE_SUFFIX;
    }
    /**
   * Returns the number of minutes since the epoch.
   * @return {number}
   */ function currentTime() {
        return Math.floor(new Date().getTime() / expiryMilliseconds);
    }
    /**
   * Wrapper functions for localStorage methods
   */ function getItem(key) {
        return localStorage.getItem(CACHE_PREFIX + cacheBucket + key);
    }
    function setItem(key, value) {
        // Fix for iPad issue - sometimes throws QUOTA_EXCEEDED_ERR on setItem.
        localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
        localStorage.setItem(CACHE_PREFIX + cacheBucket + key, value);
    }
    function removeItem(key) {
        localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
    }
    function eachKey(fn) {
        var prefixRegExp = new RegExp('^' + CACHE_PREFIX + escapeRegExpSpecialCharacters(cacheBucket) + '(.*)');
        // We first identify which keys to process
        var keysToProcess = [];
        var key, i;
        for(i = 0; i < localStorage.length; i++){
            key = localStorage.key(i);
            key = key && key.match(prefixRegExp);
            key = key && key[1];
            if (key && key.indexOf(CACHE_SUFFIX) < 0) keysToProcess.push(key);
        }
        // Then we apply the processing function to each key
        for(i = 0; i < keysToProcess.length; i++)fn(keysToProcess[i], expirationKey(keysToProcess[i]));
    }
    function flushItem(key) {
        var exprKey = expirationKey(key);
        removeItem(key);
        removeItem(exprKey);
    }
    function flushExpiredItem(key) {
        var exprKey = expirationKey(key);
        var expr = getItem(exprKey);
        if (expr) {
            var expirationTime = parseInt(expr, EXPIRY_RADIX);
            // Check if we should actually kick item out of storage
            if (currentTime() >= expirationTime) {
                removeItem(key);
                removeItem(exprKey);
                return true;
            }
        }
    }
    function warn(message, err) {
        if (!warnings) return;
        if (!('console' in window) || typeof window.console.warn !== 'function') return;
        window.console.warn("lscache - " + message);
        if (err) window.console.warn("lscache - The error was: " + err.message);
    }
    function calculateMaxDate(expiryMilliseconds) {
        return Math.floor(8.64e15 / expiryMilliseconds);
    }
    var lscache = {
        /**
     * Stores the value in localStorage. Expires after specified number of minutes.
     * @param {string} key
     * @param {Object|string} value
     * @param {number} time
     * @return {boolean} whether the value was inserted successfully
     */ set: function(key, value, time) {
            if (!supportsStorage()) return false;
            // If we don't get a string value, try to stringify
            // In future, localStorage may properly support storing non-strings
            // and this can be removed.
            if (!supportsJSON()) return false;
            try {
                value = JSON.stringify(value);
            } catch (e) {
                // Sometimes we can't stringify due to circular refs
                // in complex objects, so we won't bother storing then.
                return false;
            }
            try {
                setItem(key, value);
            } catch (e) {
                if (isOutOfSpace(e)) {
                    // If we exceeded the quota, then we will sort
                    // by the expire time, and then remove the N oldest
                    var storedKeys = [];
                    var storedKey;
                    eachKey(function(key, exprKey) {
                        var expiration = getItem(exprKey);
                        if (expiration) expiration = parseInt(expiration, EXPIRY_RADIX);
                        else // TODO: Store date added for non-expiring items for smarter removal
                        expiration = maxDate;
                        storedKeys.push({
                            key: key,
                            size: (getItem(key) || '').length,
                            expiration: expiration
                        });
                    });
                    // Sorts the keys with oldest expiration time last
                    storedKeys.sort(function(a, b) {
                        return b.expiration - a.expiration;
                    });
                    var targetSize = (value || '').length;
                    while(storedKeys.length && targetSize > 0){
                        storedKey = storedKeys.pop();
                        warn("Cache is full, removing item with key '" + storedKey.key + "'");
                        flushItem(storedKey.key);
                        targetSize -= storedKey.size;
                    }
                    try {
                        setItem(key, value);
                    } catch (e) {
                        // value may be larger than total quota
                        warn("Could not add item with key '" + key + "', perhaps it's too big?", e);
                        return false;
                    }
                } else {
                    // If it was some other error, just give up.
                    warn("Could not add item with key '" + key + "'", e);
                    return false;
                }
            }
            // If a time is specified, store expiration info in localStorage
            if (time) setItem(expirationKey(key), (currentTime() + time).toString(EXPIRY_RADIX));
            else // In case they previously set a time, remove that info from localStorage.
            removeItem(expirationKey(key));
            return true;
        },
        /**
     * Retrieves specified value from localStorage, if not expired.
     * @param {string} key
     * @return {string|Object}
     */ get: function(key) {
            if (!supportsStorage()) return null;
            // Return the de-serialized item if not expired
            if (flushExpiredItem(key)) return null;
            // Tries to de-serialize stored value if its an object, and returns the normal value otherwise.
            var value = getItem(key);
            if (!value || !supportsJSON()) return value;
            try {
                // We can't tell if its JSON or a string, so we try to parse
                return JSON.parse(value);
            } catch (e) {
                // If we can't parse, it's probably because it isn't an object
                return value;
            }
        },
        /**
     * Removes a value from localStorage.
     * Equivalent to 'delete' in memcache, but that's a keyword in JS.
     * @param {string} key
     */ remove: function(key) {
            if (!supportsStorage()) return;
            flushItem(key);
        },
        /**
     * Returns whether local storage is supported.
     * Currently exposed for testing purposes.
     * @return {boolean}
     */ supported: function() {
            return supportsStorage();
        },
        /**
     * Flushes all lscache items and expiry markers without affecting rest of localStorage
     */ flush: function() {
            if (!supportsStorage()) return;
            eachKey(function(key) {
                flushItem(key);
            });
        },
        /**
     * Flushes expired lscache items and expiry markers without affecting rest of localStorage
     */ flushExpired: function() {
            if (!supportsStorage()) return;
            eachKey(function(key) {
                flushExpiredItem(key);
            });
        },
        /**
     * Appends CACHE_PREFIX so lscache will partition data in to different buckets.
     * @param {string} bucket
     */ setBucket: function(bucket) {
            cacheBucket = bucket;
        },
        /**
     * Resets the string being appended to CACHE_PREFIX so lscache will use the default storage behavior.
     */ resetBucket: function() {
            cacheBucket = '';
        },
        /**
     * @returns {number} The currently set number of milliseconds each time unit represents in
     *   the set() function's "time" argument.
     */ getExpiryMilliseconds: function() {
            return expiryMilliseconds;
        },
        /**
     * Sets the number of milliseconds each time unit represents in the set() function's
     *   "time" argument.
     * Sample values:
     *  1: each time unit = 1 millisecond
     *  1000: each time unit = 1 second
     *  60000: each time unit = 1 minute (Default value)
     *  360000: each time unit = 1 hour
     * @param {number} milliseconds
     */ setExpiryMilliseconds: function(milliseconds) {
            expiryMilliseconds = milliseconds;
            maxDate = calculateMaxDate(expiryMilliseconds);
        },
        /**
     * Sets whether to display warnings when an item is removed from the cache or not.
     */ enableWarnings: function(enabled) {
            warnings = enabled;
        }
    };
    // Return the module
    return lscache;
});

},{}]},[], null, "parcelRequire5b81", {})

//# sourceMappingURL=transitrouter.e9d95179.js.map
